export const heartBeatRhythm = (timestamp: number, bpm: number) => {
  const timeInSeconds = timestamp / 1000;
  const beatInterval = 60 / bpm;

  const timeInBeatCycle = timeInSeconds % beatInterval;

  let value;

  if (timeInBeatCycle < 0.1 * beatInterval) {
    value =
      0.5 + 0.1 * Math.sin((Math.PI / (0.1 * beatInterval)) * timeInBeatCycle);
  } else if (timeInBeatCycle < 0.15 * beatInterval) {
    const qrsProgress =
      (timeInBeatCycle - 0.1 * beatInterval) / (0.05 * beatInterval);
    if (qrsProgress < 0.5) {
      value = 0.5 - qrsProgress * 1.0;
    } else {
      value = 0.5 + (1 - Math.abs(2 * qrsProgress - 1)) * 1.5;
    }
  } else if (timeInBeatCycle < 0.25 * beatInterval) {
    const tProgress =
      (timeInBeatCycle - 0.15 * beatInterval) / (0.1 * beatInterval);
    value = 0.5 + 0.15 * Math.sin(Math.PI * tProgress);
  } else {
    value = 0.5;
  }

  return value;
};
